import { notification } from 'antd'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getAudioLink, retryTranscription, searchMediaCaptures } from './transcriptsApi'
import { TranscriptFilters } from './transcriptsModel'

export const useTranscriptsSearchQuery = (filters: TranscriptFilters) => {
  return useQuery({
    queryKey: ['transcripts', 'search', filters],
    queryFn: () => searchMediaCaptures(filters),
    keepPreviousData: true,
    retry: false,
    onError: () => {
      notification.error({ message: 'Failed to load transcripts' })
    },
  })
}

export const useAudioLinkQuery = (capture: { id: string; tenantId: number } | null) => {
  return useQuery({
    queryKey: ['transcripts', 'audio-link', capture?.id],
    queryFn: () => getAudioLink(capture!.id, capture!.tenantId),
    enabled: !!capture,
    retry: false,
    staleTime: 0,
    cacheTime: 0,
    onError: () => {
      notification.error({ message: 'Failed to load audio' })
    },
  })
}

export const useFetchAudioLinkMutation = () => {
  return useMutation({
    mutationFn: ({ id, tenantId }: { id: string; tenantId: number }) => getAudioLink(id, tenantId),
    onError: () => {
      notification.error({ message: 'Failed to load audio' })
    },
  })
}

export const useRetryTranscriptionMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, tenantId }: { id: string; tenantId: number }) => retryTranscription(id, tenantId),
    onSuccess: () => {
      notification.success({ message: 'Transcription queued for retry' })
      queryClient.invalidateQueries(['transcripts', 'search'])
    },
    onError: () => {
      notification.error({ message: 'Failed to retry transcription' })
    },
  })
}
